<template>
  <div class="start-game-screen">
    <div class="header part">
      <div class="title">What</div>
      <div class="highlighted-text">Can I win?</div>
      <!-- <div class="subtitle">
        Score over <span class="highlighted-text">300pts</span> to win
      </div>-->
    </div>

    <div class="part prizes">
      <div class="prize">
        <div class="img-container">
          <img src="@/assets/nokia-8110.png" alt="1st Prize - Nokia 8110 4g" />
        </div>
        <p>
          Nokia 8110
          <br />phone
        </p>
      </div>
      <div class="prize">
        <div class="img-container">
          <img class="amazon-img" src="@/assets/amazon.png" alt="2nd Prize - 20$ Amazon Voucher" />
        </div>
        <p>
          $20 Amazon
          <br />Voucher
        </p>
      </div>
      <div class="prize">
        <div class="img-container">
          <img
            class="covve-scan-img"
            src="@/assets/covve-scan.png"
            alt="3rd Prize - Covve Business card scanner lifetime access"
          />
        </div>
        <p>
          Business card
          <br />scanner
        </p>
      </div>
    </div>

    <div class="part play-now">
      <a @click="handlePlayAgain" class="img-a-button">
        <img src="@/assets/btn-play.png" alt="Play now!" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handlePlayAgain() {
      this.$emit("start-game");
    },
    scrollToPrizes() {
      document.querySelector(".prize .bubble").scrollIntoView({
        block: "start",
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.start-game-screen {
  background-position: 0px 40px;
  background-image: linear-gradient(rgba(#2b0a31, 0.98), rgba(#100513, 0.9)),
    url("../assets/fake-snake-bg.png");
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  padding: 10px 10px;
  flex-grow: 1;

  .part {
    margin: 15px 0;
  }

  .header {
    .title {
      font-size: 1.2rem;
    }
  }

  .prizes {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    text-align: center;
    .prize {
      // flex: 0 1 33.3%;
      flex: 0 1 100%;
      .img-container {
        min-height: 100px;
        max-height: 100px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      img {
        max-width: 55%;
        max-height: 100%;
      }

      .covve-scan-img {
        margin: 15px 0 0 0;
      }

      p {
        margin-top: 10px;
      }
    }
  }

  .social-buttons a {
    box-shadow: none;
    margin: 0 15px;
    &:hover {
      transform: translateY(-5px);
    }
  }

  p {
    font-size: 0.625rem;
  }
}
</style>
